import Swiper from 'swiper/bundle';

export default function () {
    let wrap = '.feed-swiper';
    let element = '.feed-swiper__container';
    let elemPagination = '.swiper-pagination';
    let list = {};

    if ($(wrap).length === 0) {
        return false;
    }

    $(wrap)
        .each((i, item) => {
            let $item = $(item);

            if ($item.hasClass('slide-off')) {
                return true;
            }

            let idName = $(element, item).attr('id');
            let options = {
                slidesPerView: 'auto',
                spaceBetween: 0,
                slidesPerGroup: 1,
                simulateTouch: true,
                roundLengths: true,
                navigation: {
                    prevEl: `.feed-swiper .swiper-controls__back.${idName}`,
                    nextEl: `.feed-swiper .swiper-controls__next.${idName}`,
                },
            };

            let pagination = $item.find(elemPagination);

            if (pagination.length) {
                options.pagination = {
                    el: elemPagination,
                    type: 'bullets',
                    clickable: true,
                };

                options.loop = true;
                options.autoplay = {
                    delay: 2500,
                    disableOnInteraction: false,
                };
            }

            list[idName] = new Swiper(`#${idName}`, options);

            return true;
        });
}
